import type { Product } from '@cartazo/contracts'

/**
 * Aritmética de la selección, para la carta del comensal.
 *
 * Vive aparte de `pricing.ts` por PESO, no por orden. Aquel importa `ApiError`
 * para rechazar pedidos inválidos en el servidor, y eso arrastra el barril de
 * `@cartazo/contracts` con zod dentro: 19 KB gzip que acababan en el primer
 * chunk de la carta solo por compartir fichero con estas dos funciones puras.
 *
 * Aquí solo entra el TIPO de `Product`, que se borra al compilar. Si algún día
 * hace falta lanzar un error desde este módulo, es señal de que la función no
 * pertenece aquí.
 */

/**
 * Precio unitario para pintar en la ficha mientras el comensal elige.
 *
 * Es la misma aritmética que `priceLine`, pero sin validar ni lanzar: durante la
 * selección el estado es incompleto por definición y la UI necesita mostrar un
 * total que se actualice en cada toque.
 */
export function previewUnitPrice(product: Product, optionIds: Iterable<string>): number {
  const ids = new Set(optionIds)
  let extras = 0

  for (const group of product.modifiers) {
    for (const option of group.options) {
      if (ids.has(option.id)) extras += option.price_extra
    }
  }

  return Math.max(0, product.price + extras)
}

/** ¿Están satisfechos todos los grupos obligatorios? Habilita el botón "Agregar". */
export function isSelectionComplete(product: Product, optionIds: Iterable<string>): boolean {
  const ids = new Set(optionIds)

  for (const group of product.modifiers) {
    const count = group.options.filter((o) => ids.has(o.id)).length
    if (group.required && count < Math.max(1, group.min_select)) return false
    if (count < group.min_select) return false
    if (group.max_select !== null && count > group.max_select) return false
  }

  return true
}
